export enum TravelExpenseTypeEnum {
  TRIP = 'TRIP',
  PREPARATORY = 'PREPARATORY'
}
